import React from "react";
import eyescan from "assets/images/icon/eye-scan.png";
import editpen from "assets/images/icon/edit.png";
import { cn } from "utils";


const Table = React.forwardRef(({ style, headers, data, className, handleView, ...rest }, ref) => {
    return (
        <div className="dashboard-table-section">
            <table className="table">
                <thead>
                    <tr>
                        {headers?.map((item, index) => {
                            return <th
                                key={cn(item?.headerName, String(index))}
                            >
                                {item?.headerName}
                            </th>

                        })}
                    </tr>
                </thead>
                <tbody>
                    {data.map((d, index) => {
                        return (
                            <tr
                                key={index}
                            >
                                {headers.map((header, index) => {
                                    const value = d?.[header?.key];
                                    let content;

                                    switch (header?.key) {
                                        case 'active_status': // Ensure this key matches your actual data key
                                            content = <button className='active-button'>Active</button>;
                                            break;
                                        case 'action': // Assuming this is the column for action buttons
                                            content = (
                                                <>
                                                    <img src={editpen} alt="edit icon" style={{ marginRight: '20px' }} />
                                                    <img className='ms-2' src={eyescan} alt="eye scan" />
                                                </>
                                            );
                                            break;
                                        default:
                                            content = value;
                                    }

                                    return (
                                        <td key={index} align={header?.key === 'action'? 'right':'left'}>
                                            {content}
                                        </td>
                                    );
                                })}


                            </tr>
                        )
                    })}

                </tbody>
            </table>
        </div>
    )
});

Table.displayName = "Table";

export default Table;